// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';


const AdminSponsorStudyListItem = ({  match, study }) => {
  return (
    <Link to={`/admin/content-management/studies/${study._id}`} className="-item">
      {study.name}
      <div className="-icon">
        <i className="far fa-chevron-right"/>
      </div>
    </Link>

  )
}

AdminSponsorStudyListItem.propTypes = {
  study: PropTypes.object.isRequired
}

export default withRouter(AdminSponsorStudyListItem);



// WEBPACK FOOTER //
// modules/study/components/AdminSponsorStudyListItem.js.jsx